module.exports = __webpack_public_path__ + "media/images/carbon_hospitals/covid19/sp/relation_link_child_down-7af4e609fcb53912ea1b7eb86924992f.png";